var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.82927 0C4.85518 0 3.2439 1.6113 3.2439 3.58537C3.2439 5.55943 4.85518 7.17073 6.82927 7.17073C8.80335 7.17073 10.4146 5.55943 10.4146 3.58537C10.4146 1.6113 8.80335 0 6.82927 0ZM6.82927 1.02439C8.24974 1.02439 9.39024 2.16491 9.39024 3.58537C9.39024 5.00582 8.24974 6.14634 6.82927 6.14634C5.4088 6.14634 4.26829 5.00582 4.26829 3.58537C4.26829 2.16491 5.4088 1.02439 6.82927 1.02439ZM7 7.51219C3.13086 7.51219 0 10.6431 0 14.5122V15.1951C1.35818e-05 15.331 0.0539813 15.4612 0.150034 15.5573C0.246086 15.6533 0.376357 15.7073 0.512195 15.7073H13.4878C13.6236 15.7073 13.7539 15.6533 13.85 15.5573C13.946 15.4612 14 15.331 14 15.1951V14.5122C14 10.6431 10.8691 7.51219 7 7.51219ZM7 8.5366C10.3193 8.5366 12.9756 11.1929 12.9756 14.5122V14.6829H1.02439V14.5122C1.02439 11.1929 3.68065 8.5366 7 8.5366Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.13289f21e99cbee03f3870536dc8b70a.svg";
export { ForwardRef as ReactComponent };